import React, { useEffect, useState } from "react";
import { getTelemetry } from "../lib/api";

export default function Telemetry() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setData(await getTelemetry());
      } catch (e) {
        setErr(e?.response?.data?.detail || e.message);
      }
    })();
  }, []);

  if (err) return <div className="p-8 text-sm text-red-700">{err}</div>;
  if (!data) return <div className="p-8 text-sm text-zinc-500">Loading…</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-6" data-testid="telemetry-page">
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900">LLM Telemetry</h1>
      <p className="text-sm text-zinc-500 mt-1">
        Phase 0 ships the rails — no live LLM calls yet. Phase 5 wires Anthropic / OpenAI / Gemini / Perplexity.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6" data-testid="telemetry-totals">
        <Stat label="calls" value={data.total?.count ?? 0} />
        <Stat label="prompt tokens" value={data.total?.prompt_tokens ?? 0} />
        <Stat label="completion tokens" value={data.total?.completion_tokens ?? 0} />
        <Stat label="est. cost USD" value={`$${(data.total?.cost_estimate_usd ?? 0).toFixed(4)}`} />
      </div>

      <div className="mt-8 border border-zinc-200 rounded-lg bg-white">
        <div className="px-4 py-2 border-b border-zinc-200 text-[10px] font-mono uppercase tracking-wider text-zinc-500">
          Usage by provider / model
        </div>
        <table className="w-full data-table">
          <thead>
            <tr>
              <th>Provider</th><th>Model</th><th>Calls</th><th>Prompt tok</th><th>Comp tok</th><th>Est. $</th>
            </tr>
          </thead>
          <tbody>
            {(data.by_provider_model || []).length === 0 && (
              <tr><td colSpan={6} className="text-center text-zinc-400 py-6 text-sm">No LLM calls recorded yet (Phase 0).</td></tr>
            )}
            {(data.by_provider_model || []).map((r, i) => (
              <tr key={i}>
                <td className="font-mono">{r.provider}</td>
                <td className="font-mono">{r.model}</td>
                <td className="font-mono">{r.count}</td>
                <td className="font-mono">{r.prompt_tokens}</td>
                <td className="font-mono">{r.completion_tokens}</td>
                <td className="font-mono">${r.cost_estimate_usd?.toFixed?.(4) ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border border-zinc-200 rounded-lg p-3 bg-white">
      <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="text-xl font-mono text-zinc-900 mt-1">{value}</div>
    </div>
  );
}
